import React from 'react';
import FilterPill from '../FilterPill/FilterPill';
import './InlineFilterPills.css';

interface InlineFilterPillsProps {
  value: string[];
  availableOptions: string[];
  onChange: (value: string[]) => void;
  displayMap?: Record<string, string>;
  minSelection?: number;
  disabled?: boolean;
  placeholder?: string;
  maxDisplay?: number;
  showAddButton?: boolean;
}

const InlineFilterPills: React.FC<InlineFilterPillsProps> = ({
  value,
  availableOptions,
  onChange,
  displayMap,
  minSelection = 0,
  disabled = false,
  placeholder = '+ Add',
  maxDisplay,
  showAddButton = true,
}) => {
  const handleToggle = (option: string) => {
    if (disabled) return;
    
    const newValue = value.includes(option)
      ? value.filter(v => v !== option)
      : [...value, option];
    
    // Ensure minimum selection
    if (minSelection > 0 && newValue.length < minSelection) {
      return;
    }
    
    onChange(newValue);
  };

  const handleAdd = (option: string) => {
    if (disabled || value.includes(option)) return;
    onChange([...value, option]);
  };

  // Determine what to display
  const displayedOptions = maxDisplay && value.length > maxDisplay 
    ? value.slice(0, maxDisplay)
    : value;
    
  const hiddenCount = value.length - displayedOptions.length;
  
  // Options available to add
  const availableToAdd = availableOptions.filter(opt => !value.includes(opt));

  return (
    <div className={`inline-filter-pills ${disabled ? 'disabled' : ''}`}>
      <div className="filter-pill-group">
        {displayedOptions.map(option => (
          <FilterPill
            key={option}
            label={displayMap?.[option] || option}
            active={true}
            onToggle={() => handleToggle(option)}
          />
        ))}
        {hiddenCount > 0 && (
          <span className="filter-pill-overflow">+{hiddenCount} more</span>
        )}
        {showAddButton && availableToAdd.length > 0 && (
          <div className="filter-pill-add-dropdown">
            <button className="filter-pill-add-button">{placeholder}</button>
            <div className="filter-pill-dropdown-content">
              {availableToAdd.map(option => (
                <div
                  key={option}
                  className="filter-pill-dropdown-item"
                  onClick={() => handleAdd(option)}
                >
                  {displayMap?.[option] || option}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InlineFilterPills;